
<div class="dcf-main-content dcf-wrapper">
  <!-- TemplateBeginEditable name="maincontentarea" -->
  <!-- Personal Information -->
  @if (user != null) {
    <div class="dcf-bleed">
      <div class="dcf-wrapper dcf-pb-8">
        <div class="personal-info">
          <h2 class="inline">Personal Information</h2>
          @if (!isEditing) {
            <button class="dcf-btn dcf-btn-secondary dcf-float-right" (click)="isEditing = true" id="personalInformationEditButton">Edit</button>
          }
          <div>
            <label class="dcf-label" for="firstName" id="firstNameLabel">First Name: </label>
            @if (!isEditing) {
              <span>{{user.firstName}}</span>
            }
            @if (isEditing) {
              <input type="text" name="firstNameInput" [(ngModel)]="user.firstName" />
            }
          </div>
          <div>
            <label class="dcf-label" for="lastName" id="lastNameLabel">Last Name: </label>
            @if (!isEditing) {
              <span>{{user.lastName}}</span>
            }
            @if (isEditing) {
              <input  [(ngModel)]="user.lastName" type="text" id="lastNameInput" />
            }
          </div>
          <div>
            <label class="dcf-label" for="email" id="emailLabel">Email:</label>
            @if (!isEditing) {
              <span>{{user.email}}</span>
            }
            @if (isEditing) {
              <input  [(ngModel)]="user.email" type="text" id="emailInput" disabled />
            }
          </div>
          <div>
            <label class="dcf-label" for="phoneNumber" id="phoneNumberLabel">Phone Number: </label>
            @if (!isEditing) {
              <span>{{user.phoneNumber}}</span>
            }
            @if (isEditing) {
              <input  [(ngModel)]="user.phoneNumber" type="text" id="phoneNumberInput" />
            }
          </div>
          @if (isEditing) {
            <button (click)="save()" class="dcf-btn dcf-btn-secondary" id="personalInformationSaveButton">Save</button>
          }
          @if (isEditing) {
            <button (click)="reset()" class="dcf-btn dcf-btn-primary" id="personalInformationCancelButton">Cancel</button>
          }
        </div>
      </div>
    </div>
  }
  <!-- TemplateEndEditable -->
</div>